import {
    FirstSectionWrap,
    BlockTitle,
    AboutBlock
} from './style'
import config from '../../config/env'
const About = () =>{
    return(
        <article>
            <FirstSectionWrap>
                <div className="block flexSpaceBetween">
                    <div>
                        <BlockTitle>关于我们</BlockTitle>
                        
                    </div>
                    <img width="495" src={config.baseUrl+"/hitcloud/home/case/about-1-1.png"} />
                </div>
            </FirstSectionWrap>
            <AboutBlock>
                <h2>点云互联·云平台</h2>
                <div></div>
                <p>点云互联在国家市场监督管理总局-中国标准化研究院的工作指导下，紧密围绕李克强总理提出制定的“互联网+”行动计划，立足于物联大数据技术，完成了国家级的“互联网+物联大数据标签” 项目；促进政府相关工作简政放权放管结合职能转变，成为了中国标准化研究院的战略合作伙伴；并为国务院优化经济结构、推动绿色循环低碳发展、加快生态文明建设部署的节能减排工作提供有力的数据支撑。通过“互联网+物联网标签”打造出“政府+企业+消费者”的绿色生态。</p>
                <h2>联系我们</h2>
                <div></div>
                <p>邮箱：zhanghe@hitworth.com<br/> 电话：15210016007</p>
            </AboutBlock>
        </article>
    )
}

export default About;